import { FrameWorkChange, FrameWorkGetDefaulValue, FrameWorkGetPrimaryColorButton, FrameWorkGetSecundaryColorButton, FrameWorkHideAlert, FrameWorkMessageErrorAlert, FrameWorkMessageSuccessAlert, FrameWorkPutTextToActiveInactiveUser, FrameWorkPutValueIfEditByDefault, FrameWorkSimpleMessageState, FrameWorkVerifyDataIsCompleted, OrdenExpressNavegatePath, OrdenExpressValidateSecurity } from 'orden_express/frameWork/frameWork';
import { setMessageSaveState } from 'orden_express/users/usersActions';
import { requestGetCities, requestSaveDeliveryPoint } from 'orden_express/users/usersEpic';
import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { Button, Card, CardBody, CardFooter, CardHeader, CardTitle, FormGroup, Input, Label } from 'reactstrap';
import { bindActionCreators } from 'redux';


class UsersDeliveryPoint extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      idState: '',
      nameState: '',
      addressState: '',
      cityState: '',
      userState: '',
      informationState: '',
      longitudeState: '',
      latitudeState: '',
      activeState: '',
      id: '',
      name: '',
      address: '',
      city: '',
      user: '',
      information: '',
      longitude: '',
      latitude: '',
      active: '',
    };
    OrdenExpressValidateSecurity(this);
  }

  componentDidMount() {
    this.props.requestGetCities();
    let dataUserForEdit = this.props.userReducerState.dataUserForEdit;
    let localDeliveryPointEdit = this.props.userReducerState.dataDeliveryPointForEdit;
    FrameWorkPutValueIfEditByDefault(this, 'id', localDeliveryPointEdit, 'id', 'have-content', 1);
    FrameWorkPutValueIfEditByDefault(this, 'name', localDeliveryPointEdit, 'name', 'have-content', 1);
    FrameWorkPutValueIfEditByDefault(this, 'address', localDeliveryPointEdit, 'address', 'have-content', 1);
    FrameWorkPutValueIfEditByDefault(this, 'city', localDeliveryPointEdit, 'city', 'have-content', 1);
    FrameWorkPutValueIfEditByDefault(this, 'user', dataUserForEdit, 'id', 'have-content', 1);
    FrameWorkPutValueIfEditByDefault(this, 'information', localDeliveryPointEdit, 'information', 'have-content', 0);
    FrameWorkPutValueIfEditByDefault(this, 'longitude', localDeliveryPointEdit, 'longitude', 'have-content', 0);
    FrameWorkPutValueIfEditByDefault(this, 'latitude', localDeliveryPointEdit, 'latitude', 'have-content', 0);
    FrameWorkPutValueIfEditByDefault(this, 'active', localDeliveryPointEdit, 'active', 'have-content', 1);
    if (localDeliveryPointEdit === null) {
      this.setState({ active: 1 });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.userReducerState.messageSaveState !== prevProps.userReducerState.messageSaveState) {
      this.processMessageState(this.props.userReducerState.messageSaveState);
    }
  }

  getDataFromForm = () => {
    const localDeliveryPoint = {
      id: this.state.id,
      name: this.state.name,
      address: this.state.address,
      city: this.state.city,
      user: this.state.user,
      information: this.state.information,
      longitude: this.state.longitude,
      latitude: this.state.latitude,
      active: 1,
    };
    localDeliveryPoint.active = 0;
    if (this.state.active) {
      localDeliveryPoint.active = 1;
    }
    return localDeliveryPoint;
  }

  /**
   * Valida los campos obligatorios y ayuda a determinar
   * en ellos con un color o etiqueta visual para que el 
   * usuario los identifique
   */
  verifyData = () => {
    var dataIsCompleted = true;
    const listValidation = [
      'nameState',
      'addressState',
      'cityState',
      'userState',
      //'informationState',
      //'longitudeState',
      //'latitudeState'
    ];
    var pos=0;
    var length=listValidation.length;
    while(pos<length){
      var item=listValidation[pos];
      if (FrameWorkVerifyDataIsCompleted(this.state[item])) {
        dataIsCompleted = false;
        this.setState({ [item]: 'has-danger' });
      }
      pos++;
    }
    /*listValidation.map((item, index) => {
      if (FrameWorkVerifyDataIsCompleted(this.state[item])) {
        dataIsCompleted = false;
        this.setState({ [item]: 'has-danger' });
      }
    });*/
    if (!dataIsCompleted) {
      FrameWorkMessageErrorAlert(this, 'Faltan datos', 'Debe ingresar todos los datos solicitados')
      return;
    }
    //Al llear a este punto es que todos los datos han sido ingresados y se procede a su registro
    this.props.requestSaveDeliveryPoint(this.getDataFromForm());
    this.props.setMessageSaveState(1);
  };

  /**
   * Controla la secuencia de estados para visualizar 
   * los mensajes en el proceso de almacenamiento de un usuario
   */
  processMessageState = (pStateForMessage) => {
    switch (pStateForMessage) {
      case 1://procesando solicitud
        FrameWorkSimpleMessageState(this, 'Grabando', 'Su solicitud está en proceso ...');
        break;
      case 2:
        FrameWorkMessageSuccessAlert(this, 'Correcto!', 'Los datos fueron correctamente almacenados', this.props.history.goBack, this.props.history.goBack);
        break;
      case 3:
        var localMessageError = this.props.userReducerState.responseSaveUser;
        FrameWorkMessageErrorAlert(this, 'Error :(', localMessageError.message);
        console.error(localMessageError)
        break;
      default:
        FrameWorkHideAlert(this);
        this.props.setMessageSaveState(0);
        break;
    }
  }
  /**
   * Pinta los contenidos basados en los estados
   */
  render() {
    let {
      nameState,
      addressState,
      cityState,
      userState,
      informationState,
      longitudeState,
      latitudeState
    } = this.state;
    let localUserEdit = this.props.userReducerState.dataUserForEdit;
    let localDeliveryPointEdit = this.props.userReducerState.dataDeliveryPointForEdit;
    let localCities = this.props.userReducerState.responseGetCities.result;
    return (
      <div className='content'>
        {this.state.alert}
        <Card>
          <CardHeader>
            <CardTitle tag='h5'>Puntos de entrega del cliente {FrameWorkGetDefaulValue(localUserEdit, 'name')}</CardTitle>
          </CardHeader>
          <CardBody>

            <Input
              name='id'
              type='text'
              value={FrameWorkGetDefaulValue(localDeliveryPointEdit, 'id')}
              hidden
              readOnly
            />

            <FormGroup className={`has-label ${nameState}`}>
              <label>Nombre *</label>
              <Input
                name='name'
                type='text'
                maxLength='80'
                defaultValue={FrameWorkGetDefaulValue(localDeliveryPointEdit, 'name')}
                onChange={e => FrameWorkChange(this, e.target.value, 'name', 'have-content', '3')}
              />
              {this.state.nameState === 'has-danger' ? (
                <label className='error'>
                  Ingrese el nombre
                        </label>
              ) : null}
            </FormGroup>

            <FormGroup className={`has-label ${addressState}`}>
              <label>Dirección *</label>
              <Input
                name='address'
                type='text'
                maxLength='100'
                defaultValue={FrameWorkGetDefaulValue(localDeliveryPointEdit, 'address')}
                onChange={e => FrameWorkChange(this, e.target.value, 'address', 'have-content', 4)}
              />
              {this.state.addressState === 'has-danger' ? (
                <label className='error'>
                  Ingrese la dirección
                        </label>
              ) : null}
            </FormGroup>

            <FormGroup className={`has-label ${cityState}`}>
              <label>Ciudad *</label>
              <Select
                className={`react-select ${cityState === 'has-danger' ? 'bg-danger-drop-down' : ''}`}
                classNamePrefix='react-select'
                name='city'
                placeholder='Seleccione la ciudad'
                value={
                  (this.state.singleSelect === '' ||
                    this.state.singleSelect === undefined ||
                    this.state.singleSelect === null) ?
                    { value: FrameWorkGetDefaulValue(localDeliveryPointEdit, 'city'), label: FrameWorkGetDefaulValue(localDeliveryPointEdit, 'cityName') }
                    : this.state.singleSelect}
                options={
                  localCities.map((localCity, indexCity) => {
                    return (
                      { value: localCity.id, label: localCity.name }
                    )
                  })
                }
                onChange={value => {
                  this.setState({ singleSelect: value });
                  FrameWorkChange(this, value.value, 'city', 'have-content', '1');
                }
                }
              />
              {this.state.cityState === 'has-danger' ? (
                <label className='error'>
                  Seleccione la ciudad
                        </label>
              ) : null}
            </FormGroup>

            <FormGroup className={`has-label ${userState}`}>
              {/*<label>Usuario *</label>*/}
              <Input
                name='user'
                type='text'
                defaultValue={FrameWorkGetDefaulValue(localDeliveryPointEdit, 'user')}
                onChange={e => FrameWorkChange(this, e.target.value, 'user', 'have-content', 0)}
                hidden
                readOnly
              />
              {/*this.state.userState === 'has-danger' ? (
                    <label className='error'>
                        Ingrese el usuario*
                    </label>
                    ) : null*/}
            </FormGroup>

            <FormGroup className={`has-label ${informationState}`}>
              <label>Información</label>
              <Input
                className='textarea'
                name='information'
                type='textarea'
                maxLength='300'
                cols='80'
                rows='4'
                defaultValue={FrameWorkGetDefaulValue(localDeliveryPointEdit, 'information')}
                onChange={e => FrameWorkChange(this, e.target.value, 'information', 'have-content', 0)}
              />
              {this.state.informationState === 'has-danger' ? (
                <label className='error'>
                  Ingrese la información adicional que requiera
                    </label>
              ) : null}
            </FormGroup>

            <FormGroup className={`has-label ${longitudeState}`}>
              <label>Longitud</label>
              <Input
                name='longitude'
                type='number'
                maxLength='20'
                defaultValue={FrameWorkGetDefaulValue(localDeliveryPointEdit, 'longitude')}
                onChange={e => FrameWorkChange(this, e.target.value, 'longitude', 'have-content', 0)}
              />
              {/*this.state.longitudeState === 'has-danger' ? (
                    <label className='error'>
                        Ingrese la longitud
                    </label>
                    ) : null*/}
            </FormGroup>

            <FormGroup className={`has-label ${latitudeState}`}>
              <label>Latitud</label>
              <Input
                name='latitud'
                type='number'
                maxLength='20'
                defaultValue={FrameWorkGetDefaulValue(localDeliveryPointEdit, 'latitude')}
                onChange={e => FrameWorkChange(this, e.target.value, 'latitude', 'have-content', 0)}
              />
              {/*this.state.latitudeState === 'has-danger' ? (
                    <label className='error'>
                        Ingrese la latitud
                    </label>
                    ) : null*/}
            </FormGroup>

            <FormGroup check className='mt-2'>
              <Label check className='has-danger'>
                <Input
                  name='active'
                  type='checkbox'
                  defaultChecked={localDeliveryPointEdit === null ? 1 : FrameWorkGetDefaulValue(localDeliveryPointEdit, 'active')}
                  onChange={value => { this.setState({ active: !this.state.active }); }}
                />
                <span className='form-check-sign' />
                {FrameWorkPutTextToActiveInactiveUser(this.state.active, 1)}
              </Label>
            </FormGroup>

            <div className='category form-category'>
              * Campos obligatorios
              </div>

          </CardBody>
          <CardFooter className='text-right'>
            <Button
              color={FrameWorkGetSecundaryColorButton()}
              className='btn-round mb-0'
              style={{ width: 145 }}
              onClick={() => {
                try {
                  this.props.history.goBack();
                } catch (_) {
                  //this.props.history.push('admin/users');
                  OrdenExpressNavegatePath(this, 'users');
                }
              }}>
              <i className='icon-big nc-icon nc-minimal-left text-white' />
              Regresar
                </Button>
            <Button
              className='btn-round mt-1 mb-0 ml-4'
              color={FrameWorkGetPrimaryColorButton()}
              style={{ width: 145 }}
              onClick={this.verifyData}>
              <i className='icon-big fa fa-save text-white' />
              Grabar
                </Button>
          </CardFooter>
        </Card>
      </div>
    );
  }
}
/**
 * Gracias a este método se tiene acceso al repositorio de estados único,
 * para este caso se usa el del usuario
 * @param {*} state 
 */
const mapStateToProps = state => {
  return {
    userReducerState: state.userReducerState,
    loginReducerState: state.loginReducerState
  };
};

/**
 * Gracias a este método se pueden cambiar los estados globales
 * también permite acceder a las solicitudes del Epic para su
 * procesamiento en el backend
 * @param {*} dispatch 
 */
const mapDispatchToProps = dispatch => {
  return {
    setMessageSaveState: messageSaveState => dispatch(setMessageSaveState(messageSaveState)),
    requestGetCities: () => bindActionCreators(dispatch(requestGetCities()), dispatch),
    requestSaveDeliveryPoint: dataDeliveryPoint => bindActionCreators(dispatch(requestSaveDeliveryPoint(dataDeliveryPoint)), dispatch),
  };
};

/**
 * Responde con el componente general del Usuario en su parte del formulario de datos
 */
export default connect(mapStateToProps, mapDispatchToProps)(UsersDeliveryPoint);